import React from 'react';
import { getStravaActivityUrl } from '@/utils/attributionHelpers';

interface AttributionSource {
  type: 'garmin' | 'strava';
  deviceModel?: string;
  deviceManufacturer?: string;
  stravaActivityId?: string;
}

interface PoweredByAttributionProps {
  sources: AttributionSource[];
  theme?: 'light' | 'dark';
  layout?: 'auto';
}

export const PoweredByAttribution: React.FC<PoweredByAttributionProps> = ({
  sources,
  theme = 'light',
  layout = 'auto',
}) => {
  if (sources.length === 0) {
    return null;
  }

  const garminSource = sources.find(s => s.type === 'garmin');
  const stravaSource = sources.find(s => s.type === 'strava');

  return (
    <div className="border-t border-gray-100 pt-3 mt-4">
      <div className="flex flex-wrap items-center gap-4 text-sm">
        {/* Garmin Attribution */}
        {garminSource && (
          <div className="flex items-center gap-2">
            <img
              src="/garmin-assets/Garmin Tag-black-high-res.png"
              alt="Garmin"
              className="h-4"
              style={{ height: '16px', width: 'auto' }}
            />
            <span className="text-gray-700">
              {garminSource.deviceModel
                ? `Data tracked by ${garminSource.deviceModel.toLowerCase().startsWith('garmin') ? '' : 'Garmin '}${garminSource.deviceModel}`
                : 'Garmin Connect'}
            </span>
          </div>
        )}

        {/* Separator between attributions */}
        {garminSource && stravaSource && (
          <span className="text-gray-300">•</span>
        )}

        {/* Strava Attribution */}
        {stravaSource && (
          <div className="flex items-center gap-2">
            <img
              src="/strava-assets/api_logo_pwrdBy_strava_horiz_black.png"
              alt="Powered by Strava"
              className="h-4"
              style={{ height: '16px', width: 'auto' }}
            />
            {stravaSource.stravaActivityId && (
              <>
                <span className="text-gray-300">•</span>
                <a
                  href={getStravaActivityUrl(stravaSource.stravaActivityId)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#FC5200] font-semibold hover:underline"
                >
                  View on Strava →
                </a>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PoweredByAttribution;






